import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { useQueryClient } from '@tanstack/react-query';
import { commonQueryKeys } from '../hooks/useCommon';
import PageSection from '../components/PageSection';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    // Invalidate queries to refresh plan and subscription data
    queryClient.invalidateQueries({ queryKey: commonQueryKeys.currentPlan() });
    queryClient.invalidateQueries({ queryKey: commonQueryKeys.subscriptionStatus() });
    queryClient.invalidateQueries({ queryKey: commonQueryKeys.usage() });
  }, [queryClient]);

  const handleGoToBilling = () => {
    navigate('/billing');
  };

  return (
    <PageSection 
      title="Payment Successful"
      subtitle="Your subscription has been activated successfully."
      hideTitleOnMobile
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <Card sx={{ maxWidth: 500, width: '100%' }}>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            <CheckCircleIcon 
              sx={{ 
                fontSize: 80, 
                color: 'success.main', 
                mb: 2 
              }} 
            />
            <Typography variant="h5" component="h2" gutterBottom>
              Thank You!
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Your payment was processed successfully. Your subscription is now active.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={handleGoToBilling}
              sx={{
                background: 'linear-gradient(135deg, #8b9cff 0%, #ff6b9d 100%)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #5a6fd8 0%, #d94f7e 100%)',
                },
              }}
            >
              Go to Billing
            </Button>
          </CardContent>
        </Card>
      </Box>
    </PageSection>
  );
};

export default PaymentSuccess;

